import Gallery from 'components/molecules/gallery/Gallery';
import { useFormikContext } from 'formik';
import { IArtistMutationForm } from 'services/artists/types';

const ArtistGallery = () => {
  const { initialValues } = useFormikContext<IArtistMutationForm>();
  return (
    <Gallery<IArtistMutationForm> 
      showMainImageControls={false}
      isMainImg={initialValues.nickname.length > 0} 
    />
  );
};

export default ArtistGallery; 